import { useState } from 'react';

import endpoints from '../../../../../../api/endpoints';
import { handleResponseError } from '../../../../../../api/handleResponseError';
import { FailureSeverity, DialogError } from '../../../../../common/business-error';
import { addParams, fetchWithTokenRefresh } from '../../../../../../api/fetchWithTokenRefresh';

import { CreateNewClientProfileData } from '../interfaces';
import { getProfileCreationBusinessError } from '../businessErrors';

interface HandleCreateNewClientProfileProps {
  createNewClientProfileData: CreateNewClientProfileData;
  onSuccess: (msisdn: string, shortcode: string) => void;
  onFailure: (failureSeverity: FailureSeverity) => void;
}

export const useCreateNewClientProfile = () => {
  const [createNewClientProfileLoading, setCreateNewClientProfileLoading] = useState<boolean>(false);
  const [createNewClientProfileLoadingError, setCreateNewClientProfileError] = useState<DialogError>(null);

  const handleCreateNewClientProfile = async ({
    createNewClientProfileData,
    onSuccess,
    onFailure
  }: HandleCreateNewClientProfileProps) => {
    try {
      setCreateNewClientProfileLoading(true);
      setCreateNewClientProfileError(null);

      const response = await fetchWithTokenRefresh(
        endpoints.clientCreateOrder,
        addParams('POST', createNewClientProfileData)
      );

      if (response.status !== 200) {
        await handleResponseError(response);
      }
      const jsonData = await response.json();

      onSuccess(jsonData.otp.msisdn, jsonData.otp.ussdShortcodeToDial);
    } catch (e) {
      const { message, severity } = getProfileCreationBusinessError(e);
      onFailure(severity);
      setCreateNewClientProfileError({ message, severity });
    } finally {
      setCreateNewClientProfileLoading(false);
    }
  };

  return {
    createNewClientProfileLoadingError,
    createNewClientProfileLoading,
    handleCreateNewClientProfile
  };
};
